import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/util/auth'
import { getStore } from '@/util/util'
import { ingoreAddUrls, ingoreSimilarUrls } from '@/config/defaultSysUrls'
import router, { resetRouter } from '@/router'

// create an axios instance
const service = axios.create({
  baseURL: process.env.baseUrl, // url = base url + request url
  withCredentials: process.env.credential, // send cookies when cross-domain requests
  timeout: process.env.timeout // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {

    let ingoreFlag = true;
    for(let ingoreUrl of ingoreSimilarUrls) {
      if(config.url.indexOf(ingoreUrl) != -1) {
        ingoreFlag = false;
        break;
      }
    }
    let strUrl = config.url
    if (config.url.indexOf("?") != -1){
      strUrl = config.url.substring(0, config.url.indexOf("?"))
    }
    if (ingoreFlag &&ingoreAddUrls[strUrl] == null) {
      if (getToken()){
        config.headers.Authorization = 'bearer ' + getToken();
      }
    } else {
      config.headers.Authorization = process.env.authorBasic;
    }
    config.headers.lang = getStore("languagecode") || 'zh_CN';
    config.headers['z-l-t-version'] = 209;
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    if(response.status == 200) {
      return response.data;
    }
    if (response.status === 401) {
      // to re-login
      MessageBox.confirm('前往登录页面吗？', '', {
        confirmButtonText: '登录',
        cancelButtonText: '关闭',
        type: 'warning'
      }).then(() => {
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
      });
      return;
    } else if(response.status === 500) {
      let resp = {};
      resp.code = 3;
      resp.resp_msg = '网络异常';
      return resp;
    }
    return Promise.reject(new Error(response.statusText || 'Error'))
  },
  error => {
    console.log('err' + error) // for debug

    if (error.response.status === 401) {
      // to re-login
      router.push({
        name: 'Login',
        query : {
          "fromUrl" : window.location.href
        }
      }); 
      return;
    } else if(error.response.status === 500) {
      let resp = {};
      resp.code = 3;
      resp.resp_msg = '网络异常';
      return resp;
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/util/request.js